"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudioZone = exports.Airport = exports.LocationType = void 0;
/**
 * Location Type
 *
 * "Nearby" is a location where you return to the reporting site at EOD
 * "Distant" is a location that requires an overnight stay
 */
var LocationType;
(function (LocationType) {
    LocationType["Studio"] = "Studio";
    LocationType["Nearby"] = "Nearby";
    LocationType["Distant"] = "Distant";
    LocationType["Airport"] = "Airport";
})(LocationType || (exports.LocationType = LocationType = {}));
/**
 * Airports
 */
var Airport;
(function (Airport) {
    Airport["LaGuardia"] = "LaGuardia";
    Airport["JFK"] = "JFK";
    Airport["Newark"] = "Newark";
    Airport["LAX"] = "LAX";
})(Airport || (exports.Airport = Airport = {}));
/**
 * Studio Zones
 */
var StudioZone;
(function (StudioZone) {
    StudioZone["NewYork"] = "New York";
    StudioZone["NewYorkCity"] = "New York City";
    StudioZone["LosAngeles"] = "Los Angeles";
})(StudioZone || (exports.StudioZone = StudioZone = {}));
//# sourceMappingURL=location-types.js.map